import React from 'react'
import PropTypes from 'prop-types'
import { FormContext } from 'src/contexts'
import { useForm } from 'src/hooks'

export default function Form({ onSubmit, validate, disabled, initialValues, dependentFields, ...props }) {
  return (
    <FormContext.Provider
      value={useForm({ onSubmit, validate, disabled, initialValues, dependentFields })}
      {...props}
    />
  )
}

Form.propTypes = {
  onSubmit: PropTypes.func,
  validate: PropTypes.func,
  disabled: PropTypes.bool,
  initialValues: PropTypes.any,
  dependentFields: PropTypes.array,
}
